import clsx from "clsx";
import React from "react";
import "./settingsPageHeaderRoot.scss";

interface ISettingsPageHeaderRootProps extends React.ComponentPropsWithoutRef<"div"> { }

export const SettingsPageHeaderRoot = (props: ISettingsPageHeaderRootProps) => {
    return <div {...props} className={clsx("settings-page-header-root", props.className)} />;
};
